export const Testing = {
  data () {
    return {
      obj:{
            
      },
      texteditor: '',
      name: 'Gapal',
      profilePic: null,
      uploaded: false,
      uploadUrl: 'https://www.mocky.io/v2/5d4fb20b3000005c111099e3',
      uploadHeaders: {},
      course: true,
      topics: false,
      lessons: false,
      settings: false,
      courseTab: 'course',
      lessonsTab: 'lessons',
      topicsTab: 'topics',
      settingsTab: 'settings',
      courseTitle: '',
      courseDescription: '',
      addLesson: false,
      lessonType: 'addnew',
      lessonTitle: '',
      addContent: false,
      contentType: 'HTML',
      saveToLessonList: false,
      saveToTopicList: false,
      addCourseData: [],
      addTopicData: [],
      subjectName: 1,
      options1: [
        { subjectName: 'Guitar', id: 1 },
        { subjectName: 'Piano', id: 2 }
      ],
      url: null
    }
  },
    
  methods: {
    validationcheck () {
      
      this.$validator.validateAll('Questions').then((valid) => {
        
    
      })
    
    },
    removePic () {
      const profilePic = this.profilePic
      this.$refs.profilePicRef.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        [profilePic]
      )
      this.profilePic = null
      this.uploaded = false
    },
    upload () {
      const self = this
      this.$refs.profilePicRef
        .upload(this.uploadUrl, this.uploadHeaders, [this.profilePic])
        .then(function () {
          self.uploaded = true
          setTimeout(function () {
            self.profilePic.progress(0)
          }, 500)
        })
    },
    onSelect (fileRecords) {
      this.uploaded = false
    },
    courseClicked (typeOftab) {
      if (typeOftab === 'lessons') {
        this.lessons = true
        this.topics = false
        this.settings = false
        this.course = false
      } else if (typeOftab === 'topics') {
        this.lessons = false
        this.topics = true
        this.settings = false
        this.course = false
      } else if (typeOftab === 'settings') {
        this.lessons = false
        this.topics = false
        this.settings = true
        this.course = false
      } else {
        this.lessons = false
        this.topics = false
        this.settings = false
        this.course = true
      }
    },
    
    addCard () {
      this.addCourseData.push({
        courseTitle: '',
        courseDescription: ''
      })
    },
    
    removeCard (index) {
      this.addCourseData.splice(index, 1)
    },
    
    addTopic () {
      this.addTopicData.push({
        courseTitle: '',
        courseDescription: ''
      })
    },
    removeTopic (index) {
      this.addTopicData.splice(index, 1)
    },
    
    onFileChange (e) {
      const file = e.target.files[0]
      
      this.url = URL.createObjectURL(file)
    }
  }
}